import { Box } from 'native-base';
import React from 'react';

import BulletListItem from 'app/components/BulletListItem';
import HTML from 'app/components/HTML';
import { AttractionContent } from 'app/hooks/useAttraction';

export type AttractionDetailsHighlightsProps = {
  attraction: NonNullable<AttractionContent>;
};

export default function AttractionDetailsHighlights({
  attraction,
}: AttractionDetailsHighlightsProps) {
  return (
    <Box testID="AttractionDetailsHighlights">
      {attraction.highlights?.map(({ value }) => (
        <BulletListItem key={value}>
          <HTML html={value} />
        </BulletListItem>
      ))}
    </Box>
  );
}
